import {Button, Table} from "antd";
import {EyeOutlined} from "@ant-design/icons";
import {useMemo} from "react";

const sortByName = (a, b) => {
  const valA = a && a.toUpperCase();
  const valB = b && b.toUpperCase();
  if (valB == null || valA < valB) return -1;
  if (valA == null || valA > valB) return 1;
  return 0;
};

const TableOwner = ({owners, lots, payment, longTerm, search, openTabs, rowSelection}) => {

  const lotsByOwner = useMemo(() => {
    const refsById = new Map();
    (lots || []).forEach((lot) => {
      const ownerId = lot.lot_proprietaire?.proprietaire_id;
      if (!ownerId || !lot.lot_reference) return;
      if (!refsById.has(ownerId)) refsById.set(ownerId, new Set());
      refsById.get(ownerId).add(lot.lot_reference);
    });
    const sortedById = new Map();
    refsById.forEach((refs, ownerId) => {
      sortedById.set(
        ownerId,
        [...refs].sort((a, b) => a.localeCompare(b, "fr", { numeric: true }))
      );
    });
    return sortedById;
  }, [lots]);

  const filteredOwners = useMemo(() => {
    if (!owners) return [];

    let filtered = [...owners]; // Copie pour éviter de muter l'original si nécessaire

    if (payment === "1") {
      filtered = filtered.filter(
        (item) =>
          item.proprietaire_personne?.personne_compte_bancaire?.compte_bancaire_type_paiement?.type_paiement_libelle === "Virement"
      );
    }

    if (payment === "2") {
      filtered = filtered.filter(
        (item) =>
          item.proprietaire_personne?.personne_compte_bancaire?.compte_bancaire_type_paiement?.type_paiement_libelle === "Chèque"
      );
    }

    if (longTerm === true) {
      filtered = filtered.filter(
        (pro) => pro.proprietaire_longue_duree === true
      );
    }

    if (search && search.trim() !== "") {
      const needle = search.trim().toLowerCase();
      filtered = filtered.filter((item) =>
        [
          item.proprietaire_code,
          item.proprietaire_personne?.personne_nom,
          item.proprietaire_personne?.personne_prenom,
          ...(lotsByOwner.get(item.proprietaire_id) || []),
        ]
          .filter(Boolean)
          .some((value) => value.toString().toLowerCase().includes(needle))
      );
    }

    return filtered;
  }, [owners, payment, longTerm, search, lotsByOwner]);

  const columns = [
    {
      title: "Code",
      sorter: (a, b) => parseInt(a.proprietaire_code) - parseInt(b.proprietaire_code),
      render: (record) => record.proprietaire_code,
    },
    {
      title: "Nom",
      defaultSortOrder: "ascend",
      sorter: (a, b) =>
        sortByName(
          a.proprietaire_personne.personne_nom,
          b.proprietaire_personne.personne_nom
        ),
      render: (record) => record.proprietaire_personne.personne_nom,
    },
    {
      title: "Prénom",
      sorter: (a, b) =>
        sortByName(
          a.proprietaire_personne.personne_prenom,
          b.proprietaire_personne.personne_prenom
        ),
      render: (record) => record.proprietaire_personne.personne_prenom,
    },
    {
      title: "Lots",
      render: (record) => (lotsByOwner.get(record.proprietaire_id) || []).join(" / ") || "—",
      width: "20%",
    },
    {
      title: "Afficher",
      render: (record) => (
        <Button size={'middle'}
          onClick={() => openTabs("17", "Proprietaires", record)}
        >
          <EyeOutlined />
        </Button>
      ),
      width: 100,
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={filteredOwners}
      pagination={false}
      rowKey="proprietaire_id"
      rowSelection={{
        type: "checkbox",
        ...rowSelection,
      }}
      scroll={{ y: 252 }}
      size="small"
      showSorterTooltip={false}
    />
  );
};

export default TableOwner;